export const squareImageHeader = () => {
    const menuCount = document.querySelector('.quick-nav');
    if (menuCount) {
        const amount = menuCount.childElementCount;
        const basePadding = 140;
        const amountAdded = amount * 80;
        const amountTotal = basePadding + amountAdded;
        const paddingDiv = document.querySelector(
            '.spotlight-block-mobile-view'
        );

        paddingDiv.style.paddingTop = `${amountTotal}px`;
    }
};
